module.exports = __webpack_public_path__ + "img/minAppPay.ae8d65cc.png";